import Vue from 'vue'
import VueRouter from 'vue-router'
import HelloWorld from '../components/HelloWorld.vue'
import snakedetails from '../components/Snakedetails.vue'
import about from '../components/About.vue'
import rescuekit from '../components/rescuekit.vue'
import mobileapp from '../components/mobileapp.vue'
import faq from '../components/faq.vue'
import snakesbiology from '../components/snakesbiology.vue'
import venomfaq from '../components/venomfaq.vue'
import legalissuesfaq from '../components/legalissuesfaq.vue'
import contactus from '../components/contactus.vue'
import PageNotFound from '../components/PageNotFound.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'helloworld',
    component: HelloWorld
  },
  {
    path: '/snakedetails/:id',
    name: 'snakedetails',
    component: snakedetails,
    props: true
  },
  {
    path: '/about',
    name: 'about',
    component: about,
  },
  {
    path: '/rescuekit',
    name: 'rescuekit',
    component: rescuekit,
  },
  {
    path: '/mobileapp',
    name: 'mobileapp',
    component: mobileapp,
  },
  {
    path: '/faq',
    name: 'faq',
    component: faq,
  },
  {
    path: '/snakesbiology',
    name: 'snakesbiology',
    component: snakesbiology,
  },
  {
    path: '/venomfaq',
    name: 'venomfaq',
    component: venomfaq,
  },
  {
    path: '/legalissuesfaq',
    name: 'legalissuesfaq',
    component: legalissuesfaq,
  },
  {
    path: '/contactus',
    name: 'contactus',
    component: contactus,
  },
  { path: "*", component: PageNotFound }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  },
})

export default router
